import { Station } from '@mi-front/core';

export function isVideoStation(station: Station) {
  return station?.format === 'mpegts';
}

export function isAudioStation(station: Station) {
  return !isVideoStation(station);
}
